import Nullstack from 'nullstack';
export default function IconYoga({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-yoga",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "4",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M4 20h4l1.5 -3"
  }), "   ", Nullstack.element("path", {
    d: "M17 20l-1 -5h-5l1 -7"
  }), "   ", Nullstack.element("path", {
    d: "M4 10l4 -1l4 -1l4 1.5l4 1.5"
  }), " ");
}